/**
 * @ngdoc directive
 * @name databasesHeader
 * @module flowingly.runner.setup
 * @description This component is used to display the header for the databases and will contain controls
 * @usage
 * ```
      <databases-header on-databases-updated="$ctrl.handleDatabasesUpdated()"></databases-header>
 * ``` 
 * NOTE: Minimal content for now, but this might grow
 */
import { FlowinglyPermissions } from '@Shared.Angular/flowingly.services/flowingly.constants';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.setup').component('databasesHeader', {
  template:
    '<button ng-if="$ctrl.canAddDatabase" ng-click="$ctrl.onAddDatabaseClick()" class="btn btn-primary mt-25" data-testid="add-database-button">Add Database</button>',
  controller: [
    '$state',
    'APP_CONFIG',
    'permissionsService',
    function ($state, APP_CONFIG, permissionsService) {
      let $ctrl = this;

      $ctrl.canAddDatabase =
        APP_CONFIG.enableDatabaseFeature &&
        permissionsService.currentUserHasPermission(
          FlowinglyPermissions.SETUP_DATABASE_ACCESS
        );

      $ctrl.onAddDatabaseClick = () => {
        if (!$ctrl.canAddDatabase) {
          return;
        }

        $state.go(STATE_MAPPINGS.createDatabase);
      };
    }
  ]
});
